
import { Subscription } from '@/types/subscription';
import { sendTrialExpiryEmail } from '@/utils/emailNotificationService';

/**
 * Filter subscriptions based on search query
 */
export const filterSubscriptions = (
  subscriptions: Subscription[],
  searchQuery: string
): Subscription[] => {
  if (!searchQuery.trim()) {
    return subscriptions;
  }
  
  const query = searchQuery.toLowerCase();
  
  return subscriptions.filter(sub => 
    sub.businessName.toLowerCase().includes(query) ||
    sub.plan.toLowerCase().includes(query) ||
    sub.status.toLowerCase().includes(query)
  );
};

/**
 * Send trial expiry reminder to a customer
 */
export const sendTrialReminder = async (
  subscription: Subscription
): Promise<boolean> => {
  if (!subscription.trialEndDate) return false;
  
  try {
    // In a real app, this would use the customer's email from the subscription
    const success = await sendTrialExpiryEmail(
      'customer@example.com',
      subscription.businessName,
      subscription.trialEndDate
    );
    
    return success;
  } catch (error) {
    console.error('Error sending trial reminder:', error);
    return false;
  }
};

/**
 * Update a subscription in the collection
 */
export const updateSubscription = (
  subscriptions: Subscription[],
  updatedSubscription: Subscription
): Subscription[] => {
  return subscriptions.map(sub => 
    sub.id === updatedSubscription.id ? updatedSubscription : sub
  );
};
